import React from 'react'
import FlexView from 'react-flexview/lib'
import { Drone } from '../../../models/hull-models/Drone'
import { SkyPaper } from '../Frames/SkyPaper'
import { getSvg } from './EquipmentView'
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService'
import { BrowserView, MobileView } from 'react-device-detect'
import { isUK } from '../../../services/utils'
import { useMediaQuery } from '@material-ui/core'
import dayjs from 'dayjs';

interface PolicyDroneViewProps {
    drone: Drone
}

export const PolicyDroneView = ({drone, dronePremium, droneDeductible, ...props}: PolicyDroneViewProps) => {
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));
    let dateFormat = isMobile ? FirebaseService.getValue(FirebaseConfigKey.SHORT_DATE_FORMAT).toUpperCase() : FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)

    return (
        <FlexView  >
            <FlexView vAlignContent={'top'}>

                <SkyPaper small>
                    {getSvg('drone')}
                </SkyPaper>
                {/* <div className="margin-left-basic">
                    <div className="black bold text-small">Drone</div>
                    <div className="gray text-tiny margin-top-3">{drone.make}, {drone.model}, {drone.serial}</div>
                    {drone.endDate !== undefined && <div className="gray text-tiny margin-top-3">{dayjs(drone.startDate).format(dateFormat)} - {dayjs(drone.endDate).format(dateFormat)}</div>}
                    {FirebaseService.getBoolean(FirebaseConfigKey.SHOW_HULL_PREMIUMS_ON_POLICY_PAGE) &&
                        <MobileView>
                            {dronePremium > 0 && <div className="lightgrayblue text-tiny">
                                Premium: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{dronePremium.toLocaleStringToFixed()} 
                                    {!isUK() && droneDeductible > 0 &&<span> | Deductible: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{droneDeductible.toLocaleStringToFixed()}</span>}
                            </div>}
                        </MobileView>
                    }
                </div> */}
            </FlexView>
            {FirebaseService.getBoolean(FirebaseConfigKey.SHOW_HULL_PREMIUMS_ON_POLICY_PAGE) && 
                <FlexView className='margin-left-basic' column={true}>
                <div >
                    <div className="black bold text-small">Drone</div>
                    <div className="gray text-tiny margin-top-3">{drone.make}, {drone.model}, {drone.serial}</div>
                    {drone.endDate !== undefined && <div className="gray text-tiny margin-top-3">{dayjs(drone.startDate).format(dateFormat)} - {dayjs(drone.endDate).format(dateFormat)}</div>}
                    {FirebaseService.getBoolean(FirebaseConfigKey.SHOW_HULL_PREMIUMS_ON_POLICY_PAGE) &&
                        <MobileView>
                            {dronePremium > 0 && <div className="lightgrayblue text-tiny">
                                Premium: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{dronePremium.toLocaleStringToFixed()} 
                                    {!isUK() && droneDeductible > 0 &&<span> | Deductible: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{droneDeductible.toLocaleStringToFixed()}</span>}
                            </div>}
                        </MobileView>
                    }
                </div>
                    {dronePremium > 0 && <FlexView column vAlignContent={'center'} className="margin-top-3 full-height">
                        <div className="gray text-tiny">Premium: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{dronePremium.toLocaleStringToFixed()}</div>
                        {!isUK() && droneDeductible > 0 && <div className="gray text-tiny margin-top-3">Deductible: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{droneDeductible.toLocaleStringToFixed()}</div>}
                    </FlexView>}
                </FlexView>
            }
        </FlexView>
    )
}